document.addEventListener('DOMContentLoaded', function() {
  const customVariantBtn = document.querySelectorAll('[data-choose-options]');
  customVariantBtn.forEach(btn => {
    btn.addEventListener('click', function(evt) {
      let variantPicker = btn.closest('product-card');
      if (variantPicker) {
        variantPicker = variantPicker.querySelector('variant-picker');
        console.log(hasElementsExcludingScript(variantPicker));
        if (variantPicker && hasElementsExcludingScript(variantPicker)) {
          console.log('variant picker found');
          toogleVariantPicker(variantPicker);
        } else {
          changeHandler(evt, true);
        }
      }
    });
  });

  function hasElementsExcludingScript(container) {
    const elements = [...container.childNodes].filter(node =>
      (node.nodeType === 1 && node.tagName !== "SCRIPT") ||
      (node.nodeType === 3 && node.data.trim() !== "")
    );

    return elements.length > 0;
  }


  document.addEventListener('change', changeHandler);
  document.addEventListener('custom-change', changeHandler);

  function changeHandler(evt, open=false) {
    const productCard = evt.target.closest('product-card');
    let customSelect = false;
    if (productCard) {
      customSelect = productCard.querySelector('.custom-select--product-card');
    }
    if (open || productCard && (evt.target.classList.contains('custom-select--product-card') || !customSelect)) {
      const links = evt.target.closest('product-card').querySelectorAll('a');
      links.forEach(link => {
        if (link.href !== '') {
          window.location.href = link.href;
        }
      });
    }
  }

  function toogleVariantPicker(variantPicker) {
    if (variantPicker && variantPicker.getAttribute('hidden') !== null) {
      variantPicker.hidden = false;
      variantPicker.setAttribute('aria-hidden', 'false');
    } else {
      variantPicker.hidden = true;
      variantPicker.setAttribute('aria-hidden', 'true');
    }
  }

  let product = document.querySelector('#variant-meta-object');
  if (product) {
    product = JSON.parse(product.textContent);
    document.addEventListener('on:variant:change', (evt)=> {
      const mediaGallery = document.querySelector('media-gallery');
      if (evt?.detail?.variant?.id && product?.meta_object) {
        const foundImages = product.meta_object.find(meta =>
          meta.variant.some(variant => variant.id === evt.detail.variant.id)
        );
        if (foundImages) {
          changeImages(mediaGallery, foundImages.images);
        }
      }
    });
    console.log('metaObject',product);
  }

  function changeImages(mediaGallery, newImages, goToFirstSlide = false) {
    const images = mediaGallery.querySelectorAll('#gallery-viewer picture img');
    const sources = mediaGallery.querySelectorAll('#gallery-viewer picture source');
    const pictures = mediaGallery.querySelectorAll('#gallery-viewer picture');

    const qty = Math.min(newImages.length, images.length);

    for (let i = 0; i < qty; i++) {
      const src = newImages[i].src;
      images[i].src = src;
      images[i].srcset = `${src} 640w, ${src} 900w`;

      const liParent = images[i].closest('li');
      if (liParent) {
        liParent.dataset.mediaId = newImages[i].id;
      }

      if (sources[i]) {
        sources[i].srcset = `${src} 690w, ${src} 800w`;
      }
    }

    if (newImages.length < pictures.length) {
      for (let i = newImages.length; i < pictures.length; i++) {
          const liParent = pictures[i].closest('li');
          if (liParent) {
            liParent.remove();
          }
      }
    }
    changeThumbs(mediaGallery, newImages, goToFirstSlide)
  }

  function changeThumbs(mediaGallery, newThumbs, goToFirstSlide = false) {
    const thumbsImages = mediaGallery.querySelectorAll('.media-thumbs__item img');
    const thumbsItems = mediaGallery.querySelectorAll('.media-thumbs__item');

    const qty = Math.min(newThumbs.length, thumbsImages.length);

    for (let i = 0; i < qty; i++) {
      const src = newThumbs[i].src;
      thumbsImages[i].src = src;
      thumbsImages[i].srcset = `${src} 80w, ${src} 160w`;
      const liParent = thumbsImages[i].closest('li');
      if (liParent) {
        liParent.dataset.mediaId = newThumbs[i].id;
      }
    }


    if (newThumbs.length < thumbsItems.length) {
      for (let i = newThumbs.length; i < thumbsItems.length; i++) {
        thumbsItems[i].parentNode.removeChild(thumbsItems[i]);
      }
    }
    mediaGallery.init();
    mediaGallery.setActiveMedia();
    mediaGallery.goToFirstSlide();
    setTimeout(() => {
      mediaGallery.style.opacity = 1;
    }, 600);
  }

  function initUpdateImages() {
    let product = document.querySelector('#variant-meta-object');
    if (product) {
      product = JSON.parse(product.textContent);
      const mediaGallery = document.querySelector('media-gallery');
      if(product.initial_variant.id && product?.meta_object){
        const foundImages = product.meta_object.find(meta =>
          meta.variant.some(variant => variant.id === product.initial_variant.id)
        );
        if (foundImages && mediaGallery) {
          mediaGallery.dataset.noChangeVariant = true;
          changeImages(mediaGallery, foundImages.images, true);
        }
      }
    }
  }
  initUpdateImages();
});